// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3CTMZ","footer":"ModalError_footer__19oMM"};